import { Modal, Form, Tooltip } from 'antd';
import React, { useState, useEffect } from 'react';
import { SalvarComentario } from '@app/api/minuta/ItemClausula';
import { Button, Icon } from '@digital/ui';
import ListMensagem from './ListMensagem';
import TextArea from 'antd/lib/input/TextArea';

export interface PropsModalComentario {
  linhaItemId: string;
  contemComentario: boolean;
  autoClick?: boolean;
}

const ModalComentarioItem = (props: PropsModalComentario) => {
  const { linhaItemId, contemComentario } = props;
  const [recarregarMensagem, setRecarregarMensagem] = useState(false);
  const [exibirModal, setExibirModal] = useState(false);
  const [iconeComentario, setIconeComentario] = useState('');
  const textAreaId = `textAreaId${linhaItemId}`;

  useEffect(() => {
    if (contemComentario === true) {
      MudarIconeAnexo();
    }
  }, []);

  useEffect(() => {
    if (props.autoClick === true) {
      getAll();
      showModal();
    }
  }, [props.autoClick]);

  const MudarIconeAnexo = () => {
    setIconeComentario('has-comments');
  };

  const iconCommentStyle: React.CSSProperties = {
    fontSize: '20px',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
  };

  const limparCampo = () => {
    const elemento = document.getElementById(textAreaId);
    if (elemento != null) {
      document.getElementById(textAreaId).value = '';
    }
  };

  const getAll = async () => {
    setRecarregarMensagem(!recarregarMensagem);
  };

  const showModal = () => {
    limparCampo();
    setExibirModal(true);
  };

  const handleCancel = () => {
    limparCampo();
    setExibirModal(false);
  };

  const Salvar = (e: any) => {
    var isEmpty = document.getElementById(textAreaId).value.replace(/\s/g, '').length;

    if (isEmpty == 0) {
      // Verifica se a mensagem contém apenas espaços
      alert('Comentário em branco');
      return;
    }

    const text = document.getElementById(textAreaId).value;
    const form = new FormData();

    form.append('linhaItemId', linhaItemId);
    form.append('mensagem', text);

    SalvarComentario(form).then(data => {
      if (data.valid) {
        limparCampo();
        setRecarregarMensagem(!recarregarMensagem);
        MudarIconeAnexo();
      }
    });
  };

  return (
    <>
      <Tooltip title="Comentários">
        <Button
          onClick={() => {
            getAll();
            showModal();
          }}
          icon="messaging-comments"
          className={iconeComentario}
        />
      </Tooltip>
      <Modal
        title="Comentário"
        className="chat-modal"
        visible={exibirModal}
        onCancel={() => {
          handleCancel();
        }}
        footer={[
          <Button key="submit" type="link" onClick={() => handleCancel()}>
            Fechar
          </Button>,
          <Button key="submit" type="primary" onClick={e => Salvar(e)}>
            Enviar
          </Button>,
        ]}>
        <ListMensagem linhaItemId={linhaItemId} recarregarMensagem={recarregarMensagem} />
        <div className="chat-modal-message-box">
          <Form>
            <Form.Item>
              <TextArea id={textAreaId} placeholder="mensagem" autosize={{ minRows: 3, maxRows: 5 }} maxLength={300}/>
            </Form.Item>
          </Form>
        </div>
      </Modal>
    </>
  );
};

export default ModalComentarioItem;
